"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _amb = _interopRequireDefault(require("./amb.EventManager"));

var _amb2 = _interopRequireDefault(require("./amb.Logger"));

var _amb3 = _interopRequireWildcard(require("./amb.Properties"));

var _amb4 = _interopRequireDefault(require("./amb.ChannelRedirect"));

var _amb5 = _interopRequireDefault(require("./amb.Channel"));

var _amb6 = _interopRequireDefault(require("./amb.CrossClientChannel"));

var _amb7 = require("./amb.Helper");

var _amb8 = _interopRequireDefault(require("./amb.FunctionQueue"));

var _amb9 = _interopRequireDefault(require("./amb.SubscriptionCommandSender"));

var _amb10 = _interopRequireDefault(require("./amb.TransportManagement"));

var _amb11 = require("./amb.Constants");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServerConnection = function ServerConnection(cometd, baseURL) {
  var crossClientChannel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new _amb6.default();
  var connected = false;
  var disconnecting = false;
  var nodeId = null;
  var eventManager = new _amb.default({
    CONNECTION_INITIALIZED: 'connection.initialized',
    CONNECTION_OPENED: 'connection.opened',
    CONNECTION_CLOSED: 'connection.closed',
    CONNECTION_BROKEN: 'connection.broken',
    SESSION_LOGGED_IN: 'session.logged.in',
    SESSION_LOGGED_OUT: 'session.logged.out',
    SESSION_INVALIDATED: 'session.invalidated',
    SESSION_REESTABLISHED: 'session.reestablished'
  });
  var sessionStates = {
    SESSION_LOGGED_IN: 'session.logged.in',
    SESSION_LOGGED_OUT: 'session.logged.out',
    SESSION_INVALIDATED: 'session.invalidated'
  };
  var state = "closed";
  var channels = {};
  var removedChannels = {};
  var LOGGER = new _amb2.default('amb.ServerConnection');

  _initializeMetaChannelListeners();

  var sessionStatus = sessionStates.SESSION_INVALIDATED;
  var loginWindow = null;
  var loginWindowEnabled = _amb3.default['loginWindow'] === 'true';
  var lastError = null;
  var errorMessages = {
    'UNKNOWN_CLIENT': '402::Unknown client',
    'UNKNOWN_SESSION': '402::session_unknown',
    'NODE_MISMATCH': 'websocket_http_node_mismatch',
    'RECONNECT_REMEMBER_ME': 'reconnect_remember_me_http_activity',
    'HUP_SIGNAL': 'reconnect_on_hup_signal'
  };
  var loginWindowOverride = false;
  var ambServerConnection = {};
  var needToReestablishSession = false;
  var channelRedirect = new _amb4.default(cometd, ambServerConnection);
  var initialized = false;
  var SESSION_LOGOUT_OVERLAY_STYLE = 'glide.amb.session.logout.overlay.style';
  var GLIDE_REDELIVERY_DISCONNECT_TIMEOUT_IN_MINS = 'glide.amb.redelivery.disconnect.timeout.in.mins';
  var GLIDE_AMB_CLEAR_NODE_AFFINITY_COOKIE = 'glide.amb.clear_node_affinity_cookie';
  var GLIDE_SESSION_STATUS = 'glide.session.status';
  var TOUCH_HTTP_SESSION = 'session.touch.http';
  var REESTABLISH_SESSION = 'amb.ServerConnection.reestablish.session';
  var SET_HEADER_REQUEST_SENT = 'set.header.request.sent';
  var REQUEST_RECONNECTION = 'request.reconnection';
  var tokenManagementExtension = cometd.getExtension(_amb3.TOKEN_MANAGEMENT_EXTENSION);
  var subscriptionCommandSender = null;
  var transportManager = new _amb10.default(cometd);
  var connectionBrokenTimestamp = null;
  var sendRequestForNodeAffinityHeader = true;
  var rememberMeEnabled = null;
  var cookieListenerIntervalId = null;
  var reconnectOnHupTimeoutId = null;
  var lastMetaConnectTime = null;
  var lastReconnectionEventTime = null;
  var connectionURL = baseURL;
  var handshakeTimestamps = [];
  var FIVE_MINUTES_IN_SECONDS = 5 * 60 * 1000;
  var LONGPOLLING_FALLBACK_THRESHOLD = 3;
  /**
   * Connection maintenance
   */

  ambServerConnection.connect =
  /*void*/
  function () {
    // Protection against anyone who things they should be calling connect
    if (connected) {
      LOGGER.debug(">>> connection exists, request satisfied");
      return;
    }

    LOGGER.debug('Connecting to glide amb server -> ' + _amb3.default['servletURI']);
    cometd.configure({
      url: ambServerConnection.getURL(_amb3.default['servletPath']),
      logLevel: _amb3.default.logLevel,
      connectTimeout: _amb3.default['wsConnectTimeout']
    });
    cometd.handshake();
    crossClientChannel.on(REESTABLISH_SESSION, function () {
      ambServerConnection._reestablishSession(false);
    });
    crossClientChannel.on(SET_HEADER_REQUEST_SENT, function () {
      sendRequestForNodeAffinityHeader = false;
    });
    crossClientChannel.on(REQUEST_RECONNECTION, function () {
      LOGGER.debug('Received signal to reconnect');

      _checkAndReestablishSession();
    });
  };

  ambServerConnection.reload =
  /*void*/
  function () {
    cometd.reload();
  };

  ambServerConnection.abort =
  /*void*/
  function () {
    cometd.getTransport().abort();
  };

  ambServerConnection.disconnect =
  /*void*/
  function (disconnectCallback) {
    LOGGER.debug('Disconnecting from glide amb server..');
    disconnecting = true;
    cometd.disconnect(disconnectCallback);
  };

  ambServerConnection.getURL = function (ambServletPath) {
    return connectionURL + '/' + ambServletPath;
  };

  ambServerConnection.getConnectionBrokenTS = function () {
    return connectionBrokenTimestamp;
  };
  /**
   * Initialize connection event callbacks
   */


  function _initializeMetaChannelListeners() {
    cometd.addListener('/meta/handshake', this, _metaHandshake);
    cometd.addListener('/meta/connect', this, _metaConnect);
    cometd.addListener('/meta/subscribe', this, _metaSubscribe);
    cometd.addListener('/meta/unsubscribe', this, applyAMBProperties);
  }
  /**
   * Connection event listeners
   */


  function _metaHandshake(message) {
    checkWebSocketHealth(message);
    applyAMBProperties(message);

    if (getExt(message, _amb11.WS_CONNECTION_NODE_ID) !== undefined) {
      nodeId = getExt(message, _amb11.WS_CONNECTION_NODE_ID);
      LOGGER.debug("Node Id from handshake callback initially set to " + nodeId);
    }

    var logoutOverlayStyle = getExt(message, SESSION_LOGOUT_OVERLAY_STYLE);

    if (logoutOverlayStyle) {
      _amb3.default.overlayStyle = logoutOverlayStyle;
    }

    var redeliveryDisconnectTimeoutInMins = getExt(message, GLIDE_REDELIVERY_DISCONNECT_TIMEOUT_IN_MINS);
    if (redeliveryDisconnectTimeoutInMins) _amb3.default.redeliveryDisconnectTimeoutInMins = redeliveryDisconnectTimeoutInMins;
    var requestHeaderToClearNodeAffinityCookie = getExt(message, GLIDE_AMB_CLEAR_NODE_AFFINITY_COOKIE);
    if (requestHeaderToClearNodeAffinityCookie !== undefined) _amb3.default.requestHeaderToClearStickySessionCookie = getExt(message, GLIDE_AMB_CLEAR_NODE_AFFINITY_COOKIE) === true;
    sessionStatus = getExt(message, GLIDE_SESSION_STATUS);
    applySubscriptionCommandFlowProperties(message);
    setTimeout(function () {
      if (message['successful']) _connectionInitialized();
    }, 0);
  }

  function checkWebSocketHealth(message) {
    if (isWebsocketTransport()) {
      var now = new Date();
      handshakeTimestamps.push(now); // Remove handshakes older than 5 minutes

      var fiveMinutesAgo = now - FIVE_MINUTES_IN_SECONDS;

      while (handshakeTimestamps.length > 0 && handshakeTimestamps[0] < fiveMinutesAgo) {
        handshakeTimestamps.shift();
      }

      var handshakeLimitEnabled = getExt(message, _amb11.GLIDE_AMB_HANDSHAKE_LIMIT_ENABLED);

      if (handshakeLimitEnabled) {
        if (handshakeTimestamps.length >= LONGPOLLING_FALLBACK_THRESHOLD) {
          LOGGER.addInfoMessage("Transport type will switch to long-polling in next connection error");
          cometd.websocketEnabled = false;
        }
      }
    }
  }

  function getExt(message, extensionName) {
    if ((0, _amb7.isObject)(message.ext)) return message.ext[extensionName];
  }

  function _getChannel(
  /*String*/
  channelName, subscriptionOptionsCallback) {
    if (channelName in channels) return channels[channelName];
    var channel = new _amb5.default(cometd, channelName, initialized, subscriptionOptionsCallback);
    channels[channelName] = channel;
    return channel;
  }

  function _removeChannel(channelName) {
    removedChannels[channelName] = channels[channelName];
    delete channels[channelName];
  }

  function applyAMBProperties(message) {
    if (message.ext) {
      if (message.ext['glide.amb.active'] === false) {
        ambServerConnection.disconnect();
      }

      var logLevel = getExt(message, 'glide.amb.client.log.level');

      if (logLevel) {
        _amb3.default.logLevel = logLevel;
        cometd.setLogLevel(_amb3.default.logLevel);
      }

      _amb3.default.pruneFailedTransports = getExt(message, 'glide.amb.pruneFailedTransports') !== 'false';
    }
  }

  function cookieUpdateListener() {
    var cookieValue = fetchNodeCookie();

    if (cookieValue !== null) {
      clearInterval(cookieListenerIntervalId);
      cookieListenerIntervalId = null;
      rememberMeEnabled = null;
      needToReestablishSession = true;
      lastError = errorMessages['RECONNECT_REMEMBER_ME'];
      ambServerConnection.connect();
    }
  }

  function fetchNodeCookie() {
    if (typeof document.cookie !== 'undefined') {
      var cookies = document.cookie.split(';');

      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i].trim();
        if (cookie.startsWith("".concat(_amb11.NODEID_COOKIE_KEY, "="))) return cookie.substring(_amb11.NODEID_COOKIE_KEY.length + 1);
      }
    }

    return null;
  }

  function reconnectIfHttpSessionMigrated() {
    if (nodeId !== null) {
      var cookieValue = fetchNodeCookie();

      if (cookieValue !== null && nodeId !== cookieValue) {
        setTimeout(function () {
          //check cookie value again, so we don't reconnect if the http session settled back on the same node
          cookieValue = fetchNodeCookie();

          if (cookieValue !== null && nodeId !== cookieValue) {
            LOGGER.addInfoMessage('WS Connection is with ' + nodeId + ' whereas httpsession is with ' + cookieValue + '. Disconnecting WS connection');
            reconnect(errorMessages['NODE_MISMATCH']);
          }
        }, 20000);
      }
    }
  }

  function reconnectAfterTimeout(timeout) {
    if (!reconnectOnHupTimeoutId) {
      reconnectOnHupTimeoutId = setTimeout(function () {
        LOGGER.addInfoMessage('Reconnecting after ' + timeout + 'sec as the server received an HUP signal from load balancer');
        reconnect(errorMessages['HUP_SIGNAL']);
      }, timeout * 1000);
    }
  }

  function reconnect(error) {
    nodeId = null;
    disconnecting = true;
    cometd.disconnect(function () {
      LOGGER.addInfoMessage('Disconnected WS Connection. Connecting back');
      lastError = error;
      connected = false;

      _connectionClosed();

      reconnectOnHupTimeoutId = null;
      needToReestablishSession = true;
      disconnecting = false;
      ambServerConnection.connect();
    });
  }

  function _metaSubscribe(message) {
    applyAMBProperties(message);
    /** TODO: re-visit
    if (message['successful'] === false && message['subscription'])
    	_removeChannel(message['subscription']);
     */
  }

  function _getIntMessageExtProperty(valueStr, defaultVal) {
    var propValue = Math.floor(parseInt(valueStr));
    if (isNaN(propValue) || propValue < 0) propValue = defaultVal;
    return propValue;
  }

  function _getBooleanMessageExtProperty(valueStr, defaultVal) {
    var propValue = defaultVal;
    if (!(0, _amb7.isNil)(valueStr)) propValue = valueStr ? true : false;
    return propValue;
  }

  function applySubscriptionCommandFlowProperties(message) {
    if (!message.ext) return;
    var glideAMBSubscribeCommandsFlow = message.ext['subscribeCommandsFlow'];
    if (!glideAMBSubscribeCommandsFlow) return;
    var subCommandFlowDefault = _amb3.default.subscribeCommandsFlow;
    _amb3.default.subscribeCommandsFlow.enable = _getBooleanMessageExtProperty(glideAMBSubscribeCommandsFlow['enable'], subCommandFlowDefault.enable);

    if (_amb3.default.subscribeCommandsFlow.enable) {
      _amb3.default.subscribeCommandsFlow.retries = _getIntMessageExtProperty(glideAMBSubscribeCommandsFlow['retries'], subCommandFlowDefault.retries);
      _amb3.default.subscribeCommandsFlow.maxInflight = _getIntMessageExtProperty(glideAMBSubscribeCommandsFlow['maxInflight'], subCommandFlowDefault.maxInflight);
      _amb3.default.subscribeCommandsFlow.maxWait = _getIntMessageExtProperty(glideAMBSubscribeCommandsFlow['maxWait'], subCommandFlowDefault.maxWait);
      var glideAMBRetryDelay = glideAMBSubscribeCommandsFlow['retryDelay'];

      if (glideAMBRetryDelay) {
        var retryDelayDefault = _amb3.default.subscribeCommandsFlow.retryDelay;
        _amb3.default.subscribeCommandsFlow.retryDelay.min = _getIntMessageExtProperty(glideAMBRetryDelay['min'], retryDelayDefault.min);
        _amb3.default.subscribeCommandsFlow.retryDelay.max = _getIntMessageExtProperty(glideAMBRetryDelay['max'], retryDelayDefault.max);
        _amb3.default.subscribeCommandsFlow.retryDelay.increaseFactor = _getIntMessageExtProperty(glideAMBRetryDelay['increaseFactor'], retryDelayDefault.increaseFactor);
      }
    }

    _initializeSubscriptionCommandSender();
  }

  function _initializeSubscriptionCommandSender() {
    if (_amb3.default.subscribeCommandsFlow.enable) {
      LOGGER.addInfoMessage("_initializeSubscriptionCommandSender: SubscriptionCommandSender is enabled");
      if (tokenManagementExtension != null) tokenManagementExtension.updateTokenCount(_amb3.default.subscribeCommandsFlow.maxInflight);
      if (subscriptionCommandSender) subscriptionCommandSender.stop();
      subscriptionCommandSender = new _amb9.default(new _amb8.default(10000), tokenManagementExtension);
    }
  }

  function _isClearNodeAffinityCookieEnabled() {
    return _amb3.default.requestHeaderToClearStickySessionCookie;
  }

  function _resubscribeAll() {
    LOGGER.debug("Resubscribing to all!");

    for (var name in channels) {
      var channel = channels[name];
      channel && channel.resubscribeToCometD();
    }
  }

  function _unsubscribeAll() {
    LOGGER.debug("Unsubscribing from all!");

    for (var channelName in channels) {
      var channel = channels[channelName];
      channel && channel.unsubscribeFromCometD();
    }
  }

  function _metaConnect(
  /*Hash*/
  message) {
    applyAMBProperties(message);
    if (getExt(message, _amb11.GLIDE_REMEMBER_ME)) rememberMeEnabled = getExt(message, _amb11.GLIDE_REMEMBER_ME);
    if (getExt(message, _amb11.GLIDE_AMB_HUP_SIGNAL_RECONNECT_IN_SEC)) reconnectAfterTimeout(getExt(message, _amb11.GLIDE_AMB_HUP_SIGNAL_RECONNECT_IN_SEC));

    if (disconnecting) {
      setTimeout(function () {
        connected = false;

        _connectionClosed();
      }, 0);
      return;
    }

    if (connected && !isSessionInvalidated(getExt(message, GLIDE_SESSION_STATUS))) reconnectIfHttpSessionMigrated();
    var shouldTouchHttpSession = getExt(message, TOUCH_HTTP_SESSION);
    if (isWebsocketTransport() && shouldTouchHttpSession === true) ambServerConnection._touchHttpSession();
    var error = message['error'];
    if (error) lastError = error;

    _sessionStatus(message);

    var wasConnected = connected;
    connected = message['successful'] === true;
    if (!wasConnected && connected) _connectionOpened();else if (wasConnected && !connected) _connectionBroken();
    lastMetaConnectTime = new Date();
  }

  function isWebsocketTransport() {
    return _amb3.WEBSOCKET_TYPE_NAME === cometd.getTransport().getType();
  }

  function _touchHttpSession() {
    var request = new XMLHttpRequest();
    request.withCredentials = true;
    request.open("POST", ambServerConnection.getURL("amb"), true);
    request.setRequestHeader("Content-type", "application/json");
    request.send();
  }

  function _connectionInitialized() {
    LOGGER.debug('Connection initialized');
    initialized = true;
    state = "initialized";

    _publishEvent(eventManager.getEvents().CONNECTION_INITIALIZED);
  }

  function _connectionOpened() {
    LOGGER.debug('Connection opened');
    transportManager.processConnectionOpened();

    if (needToReestablishSession) {
      _setupSession();
    } else {
      channelRedirect.initialize(function () {
        _onChannelRedirectSubscriptionComplete(true);
      });
    }
  }

  function _onChannelRedirectSubscriptionComplete(emit) {
    LOGGER.debug("Resubscribing to all, except channel_redirect");
    var redirectName = channelRedirect.getName();

    for (var name in channels) {
      if (name !== redirectName) {
        var channel = channels[name];
        channel && channel.resubscribeToCometD();
      }
    }

    _publishConnectionOpened();

    if (emit) _emitCheckReconnection();
  }

  function _emitCheckReconnection() {
    LOGGER.debug('Sending signal to reconnect');
    crossClientChannel.emit(REQUEST_RECONNECTION, REQUEST_RECONNECTION);
  }

  function _publishConnectionOpened() {
    state = "opened";

    _publishEvent(eventManager.getEvents().CONNECTION_OPENED);
  }

  function _setupSession() {
    if (!_isKnownError(ambServerConnection.getLastError())) {
      LOGGER.addWarnMessage("Error connecting to server. Unkown status " + ambServerConnection.getLastError());
      return;
    }

    ambServerConnection.setLastError(null);

    ambServerConnection._sendSessionSetupRequest(function (_ref) {
      var status = _ref.status,
          response = _ref.response;

      if (status !== 200) {
        LOGGER.addWarnMessage("/amb_session_setup.do status: " + status);
        return;
      }

      needToReestablishSession = false;
      var newStatus = JSON.parse(response)['glide.session.status'];
      LOGGER.debug("/amb_session_setup.do response: " + response);

      if (!newStatus || sessionStatus === newStatus) {
        channelRedirect.initialize(function () {
          _onChannelRedirectSubscriptionComplete(false);
        });
      } else {
        channelRedirect.initialize(_publishConnectionOpened);

        _processSessionStatus(newStatus);
      }
    });
  }

  function _isKnownError(error) {
    return Object.values(errorMessages).includes(error);
  }

  function _sendRequestToSetUpGlideSession() {
    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

    // We are reconnected, but the GlideSession may not have been set up. We currently do not support
    // re-establishing a connection from an AMB message (CometD 2.X does not support asynchronous
    // request handling).
    var xhr = _buildSetUpSessionRequest();

    xhr.onload = function () {
      return callback(xhr);
    };

    xhr.send();
  }

  function _buildSetUpSessionRequest() {
    LOGGER.debug("sending /amb_session_setup.do!");
    var request = new XMLHttpRequest();
    request.withCredentials = true;
    request.open("POST", ambServerConnection.getURL("amb_session_setup.do"), true);
    request.setRequestHeader("Content-type", "application/json;charset=UTF-8");
    request.setRequestHeader("X-UserToken", window.g_ck);
    request.setRequestHeader("X-CometD-SessionID", cometd.getClientId());
    return request;
  }

  function _connectionClosed() {
    LOGGER.debug('Connection closed');
    state = "closed";

    _publishEvent(eventManager.getEvents().CONNECTION_CLOSED);
  }

  function _connectionBroken() {
    LOGGER.addErrorMessage('Connection broken');
    state = "broken";
    needToReestablishSession = true;

    _publishEvent(eventManager.getEvents().CONNECTION_BROKEN);

    connectionBrokenTimestamp = Date.now();

    _stopSubscriptionCommandSender();
  }

  function _stopSubscriptionCommandSender() {
    if (subscriptionCommandSender) {
      subscriptionCommandSender.stop();
      subscriptionCommandSender = null;
    }
  }
  /**
   * Session management/maintenance
   */


  function _sendSetHeaderToClearNodeAffinityCookie() {
    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

    var xhr = _buildSetHeaderToClearNodeAffinityCookieRequest();

    xhr.onload = function () {
      return callback(xhr);
    };

    xhr.send();
  }

  function _buildSetHeaderToClearNodeAffinityCookieRequest() {
    var request = new XMLHttpRequest();
    request.open("POST", ambServerConnection.getURL("set_clear_node_affinity_header"), true);
    return request;
  }

  function _sessionStatus(
  /*Hash*/
  message) {
    var newSessionStatus = getExt(message, GLIDE_SESSION_STATUS);
    if (!newSessionStatus || newSessionStatus === sessionStatus) return;
    loginWindowOverride = getExt(message, 'glide.amb.login.window.override') === true;

    _processSessionStatus(newSessionStatus);
  }

  function _processSessionStatus(newSessionStatus) {
    LOGGER.debug('session.status - ' + newSessionStatus);

    if (isSessionInvalidated(newSessionStatus)) {
      _invalidated();
    } else if (isLoggedOut(newSessionStatus)) {
      _loggedOut();
    } else if (isReestablished(newSessionStatus)) {
      _reestablished();
    } else if (isLoggedIn(newSessionStatus)) {
      _loggedIn();
    }

    sessionStatus = newSessionStatus;
  }

  function isLoggedIn(newSessionStatus) {
    return (sessionStatus === sessionStates.SESSION_INVALIDATED || sessionStatus === sessionStates.SESSION_LOGGED_OUT) && newSessionStatus === sessionStates.SESSION_LOGGED_IN;
  }

  function isLoggedOut(newSessionStatus) {
    return sessionStatus === sessionStates.SESSION_LOGGED_IN && newSessionStatus === sessionStates.SESSION_LOGGED_OUT;
  }

  function isReestablished(newSessionStatus) {
    return sessionStatus === sessionStates.SESSION_INVALIDATED && newSessionStatus === sessionStates.SESSION_LOGGED_OUT;
  }
  /**
   * For logged in users session invalidation happens instead of being logged out when they have remember me on
   */


  function isSessionInvalidated(newSessionStatus) {
    return (sessionStatus === sessionStates.SESSION_LOGGED_IN || sessionStatus === sessionStates.SESSION_LOGGED_OUT) && newSessionStatus === sessionStates.SESSION_INVALIDATED;
  }

  function _loggedIn() {
    LOGGER.debug("LOGGED_IN event fire!");

    _resubscribeAll();

    _publishEvent(eventManager.getEvents().SESSION_LOGGED_IN);

    ambServerConnection.loginHide();
    sendRequestForNodeAffinityHeader = true;
  }

  function _loggedOut() {
    LOGGER.debug("LOGGED_OUT event fire!");

    _unsubscribeAll();

    _publishEvent(eventManager.getEvents().SESSION_LOGGED_OUT);

    if (loginWindowEnabled && !loginWindowOverride) {
      ambServerConnection.loginShow();
    }

    reestablishSessionIfNeeded();
  }

  function _reestablished() {
    LOGGER.debug("REESTABLISHED event fire!");

    _resubscribeAll();

    _publishEvent(eventManager.getEvents().SESSION_REESTABLISHED);
  }

  function _invalidated() {
    LOGGER.debug("INVALIDATED event fire!");

    _unsubscribeAll();

    _publishEvent(eventManager.getEvents().SESSION_INVALIDATED);

    if (_isClearNodeAffinityCookieEnabled()) {
      if (navigator.locks !== undefined) navigator.locks.request('lock-set_clear_node_affinity_header', prepareSendSetHeaderRequest); // blocks multiple tabs from sending the request
      else {
        LOGGER.debug("navigator.locks.request not supported");
        prepareSendSetHeaderRequest();
      }
    }

    if (!reestablishSessionIfNeeded()) {
      ambServerConnection.disconnect(function () {
        ambServerConnection.loginHide();
        connected = false;

        _connectionClosed();

        disconnecting = false;
        if (rememberMeEnabled && deleteCookie(_amb11.NODEID_COOKIE_KEY)) cookieListenerIntervalId = setInterval(cookieUpdateListener, 5000);
      });
    }
  }
  /*
  	Calls amb_session_setup if the session status changes to logged out/invalidated and there is a REQUEST_RECONNECTION event received
  	after the last meta/connect heartbeat response. This usually means that one of the tab has logged out/session timed out. This would reduce the 
  	number of amb_session_setup calls by only making these calls to sync the cometd session status when needed.  
  */


  function reestablishSessionIfNeeded() {
    if (lastMetaConnectTime && lastReconnectionEventTime) {
      if (lastReconnectionEventTime > lastMetaConnectTime) {
        LOGGER.debug('Either the session is logged out/invalidated from a different tab. Calling reestablishSession as lastReconnectionEventTime ' + lastReconnectionEventTime + ' happened after lastMetaConnectResponseTime ' + lastMetaConnectTime);

        _reestablishSession(false);

        return true;
      }
    }

    return false;
  }

  function deleteCookie(cookie) {
    if (typeof document.cookie !== 'undefined') {
      document.cookie = cookie + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
      return true;
    }

    return false;
  }

  function prepareSendSetHeaderRequest() {
    if (sendRequestForNodeAffinityHeader) {
      LOGGER.debug("Sending set_clear_node_affinity_header");

      _emitRequestedSetHeaderToClearCookie();

      ambServerConnection._sendSetHeaderToClearNodeAffinityCookie(function (_ref2) {
        var status = _ref2.status;
        if (status !== 200) LOGGER.addErrorMessage("Error sending set_clear_node_affinity_header: " + status);else sendRequestForNodeAffinityHeader = false;
      });
    } else LOGGER.debug("set_clear_node_affinity_header not sent");
  }

  function _emitRequestedSetHeaderToClearCookie() {
    crossClientChannel.emit(SET_HEADER_REQUEST_SENT, SET_HEADER_REQUEST_SENT);
  }

  function _publishEvent(event) {
    try {
      eventManager.publish(event);
    } catch (e) {
      LOGGER.addErrorMessage("error publishing '" + event + "' - " + e);
    }
  }

  function _emitReestablishSession() {
    crossClientChannel.emit(REESTABLISH_SESSION, REESTABLISH_SESSION);
  }
  /**
   * Channel management
   */


  ambServerConnection.unsubscribeAll = function () {
    _unsubscribeAll();
  };

  ambServerConnection.resubscribeAll = function () {
    _resubscribeAll();
  };

  ambServerConnection.removeChannel = function (
  /*String*/
  channelName) {
    _removeChannel(channelName);
  };
  /**
   * Connection event management
   */


  ambServerConnection.getEvents = function () {
    return eventManager.getEvents();
  };

  ambServerConnection.getConnectionState = function () {
    return state;
  };

  ambServerConnection.getLastError = function () {
    return lastError;
  };

  ambServerConnection.setLastError = function (
  /*String*/
  error) {
    lastError = error;
  };

  ambServerConnection.getErrorMessages =
  /*Hash*/
  function () {
    return errorMessages;
  };

  ambServerConnection.isLoggedIn = function () {
    return sessionStatus === sessionStates.SESSION_LOGGED_IN;
  };

  ambServerConnection.isSessionActive = function () {
    return sessionStatus !== sessionStates.SESSION_INVALIDATED;
  };

  ambServerConnection.getChannelRedirect = function () {
    return channelRedirect;
  };

  ambServerConnection.getChannel = function (
  /*String*/
  channelName, subscriptionOptionsCallback) {
    return _getChannel(channelName, subscriptionOptionsCallback);
  };

  ambServerConnection.getChannels = function () {
    return channels;
  };

  ambServerConnection.getRemovedChannels = function () {
    return removedChannels;
  };

  ambServerConnection.getState = function () {
    return state;
  };

  ambServerConnection.getLoginWindowOverlayStyle = function () {
    return _amb3.default.overlayStyle;
  };

  ambServerConnection.loginShow = function () {
    LOGGER.debug("Show login window"); // noinspection HtmlUnknownTarget

    var modalContent = '<iframe src="/amb_login.do" style="border: 0" height="400px" width="405px"></iframe>';
    var modalTemplate = "<div id=\"amb_disconnect_modal\" tabindex=\"-1\" aria-hidden=\"true\" class=\"modal\" role=\"dialog\" style=\"".concat(_amb3.default.overlayStyle, "\">\n\t\t\t\t<div class=\"modal-dialog small-modal\" style=\"width:450px\">\n\t\t\t\t   <div class=\"modal-content\">\n\t\t\t\t\t  <header class=\"modal-header\">\n\t\t\t\t\t\t <h4 id=\"small_modal1_title\" class=\"modal-title\">Login</h4>\n\t\t\t\t\t  </header>\n\t\t\t\t\t  <div class=\"modal-body\">\n\t\t\t\t\t  </div>\n\t\t\t\t   </div>\n\t\t\t\t</div>\n\t\t\t</div>"); // Protect against GlideModal not being defined

    try {
      if (window.NOW && window.NOW.amb_themed_login === true) {
        // Renders login in modal and uses page theme
        var dialog = new GlideModal('amb_login_router'); // on older browsers the class has a different api

        if (dialog['renderWithContent']) dialog.template = modalTemplate;
        dialog.render();
        loginWindow = dialog;
      } else {
        // Renders login in modal and iframe (has white background)
        var _dialog = new GlideModal('amb_disconnect_modal'); // on older browsers the class has a different api


        if (_dialog['renderWithContent']) {
          _dialog.template = modalTemplate;

          _dialog.renderWithContent(modalContent);
        } else {
          _dialog.setBody(modalContent);

          _dialog.render();
        }

        loginWindow = _dialog;
      }
    } catch (e) {
      LOGGER.debug(e);
    }
  };

  ambServerConnection.loginHide = function () {
    if (!loginWindow) return;
    loginWindow.destroy();
    loginWindow = null;
  };

  ambServerConnection.loginComplete = function () {
    ambServerConnection.reestablishSession();
  };

  function _checkAndReestablishSession() {
    if (!connected) {
      ambServerConnection.connect();
      return;
    }

    if (sessionStatus === sessionStates.SESSION_LOGGED_OUT) _reestablishSession(false);else if (sessionStatus === sessionStates.SESSION_LOGGED_IN) lastReconnectionEventTime = new Date();
  }

  function _reestablishSession(emit) {
    ambServerConnection._sendSessionSetupRequest(function (_ref3) {
      var response = _ref3.response;
      if (!response) return;
      var status = JSON.parse(response)['glide.session.status'];

      _processSessionStatus(status);
    });

    if (emit) _emitReestablishSession();
  }

  ambServerConnection.reestablishSession = function () {
    ambServerConnection._reestablishSession(true);
  };

  ambServerConnection.subscribeToEvent =
  /*Number*/
  function (
  /*String*/
  event,
  /*Function*/
  callback) {
    // If we're already connected, and someone subscribes to the connection opened
    // event, just fire their callback
    if (eventManager.getEvents().CONNECTION_OPENED === event && connected) callback();
    return eventManager.subscribe(event, callback);
  };

  ambServerConnection.unsubscribeFromEvent =
  /*void*/
  function (
  /*Number*/
  id) {
    eventManager.unsubscribe(id);
  };

  ambServerConnection.isLoginWindowEnabled =
  /*Boolean*/
  function () {
    return loginWindowEnabled;
  };

  ambServerConnection.setLoginWindowEnabled = function (enableLoginWindow) {
    loginWindowEnabled = enableLoginWindow;
  };

  ambServerConnection.isLoginWindowOverride = function () {
    return loginWindowOverride;
  };

  ambServerConnection.getSubscriptionCommandSender = function () {
    return subscriptionCommandSender;
  };
  /* These are for testing, do not use. */


  ambServerConnection._metaConnect = _metaConnect;
  ambServerConnection._metaHandshake = _metaHandshake;
  ambServerConnection._metaSubscribe = _metaSubscribe;
  ambServerConnection._sendSessionSetupRequest = _sendRequestToSetUpGlideSession;
  ambServerConnection._onChannelRedirectSubscriptionComplete = _onChannelRedirectSubscriptionComplete;
  ambServerConnection._getChannel = _getChannel;
  ambServerConnection._removeChannel = _removeChannel;
  ambServerConnection._connectionInitialized = _connectionInitialized;
  ambServerConnection._connectionOpened = _connectionOpened;
  ambServerConnection._reestablishSession = _reestablishSession;
  ambServerConnection._touchHttpSession = _touchHttpSession;
  ambServerConnection._sendSetHeaderToClearNodeAffinityCookie = _sendSetHeaderToClearNodeAffinityCookie;
  return ambServerConnection;
};

var _default = ServerConnection;
exports.default = _default;